import { createAction } from 'redux-actions';

export const PROFILE_BOOTSTRAP = 'PROFILE_BOOTSTRAP';
export const PROFILE_BOOTSTRAPPED = 'PROFILE_BOOTSTRAPPED';
export const PROFILE_UPDATED = 'PROFILE_UPDATED';

export const PROFILE_UPDATE = 'PROFILE_UPDATE';
export const PROFILE_UPDATE_PASSWORD = 'PROFILE_UPDATE_PASSWORD';
export const PROFILE_UPDATE_EMAIL = 'PROFILE_UPDATE_EMAIL';
export const GO_LOGIN = 'GO_LOGIN';

export const updatedProfile = createAction(PROFILE_UPDATED);
export const updateProfile = createAction(PROFILE_UPDATE);
export const updatePassword = createAction(PROFILE_UPDATE_PASSWORD);
export const bootstrapProfile = createAction(PROFILE_BOOTSTRAP);
export const bootstrappedProfile = createAction(PROFILE_BOOTSTRAPPED);
export const updateEmail = createAction(PROFILE_UPDATE_EMAIL);
export const goLogin = createAction(GO_LOGIN);



// WEBPACK FOOTER //
// ./src/client/src/containers/ProfilePage/actions.js